import { Text } from '@lmc/ui-kit/src/general'
import dayjs from 'dayjs'
import styled from 'styled-components'

const Day = ({ date, isDailyView }: { date: Date; isDailyView: boolean }) => {
  const fullFormat = 'dddd D MMM'
  const shortFormat = 'ddd D MMM'

  return isDailyView ? (
    <DailyTimeText>{dayjs(date).format(fullFormat)}</DailyTimeText>
  ) : (
    <WeeklyContainer>
      <WeeklyTimeText
        $isToday={
          dayjs(date).format(shortFormat) === dayjs().format(shortFormat)
        }
        weight="medium"
      >
        {dayjs(date).format(shortFormat)}
      </WeeklyTimeText>
    </WeeklyContainer>
  )
}
const DailyTimeText = styled(Text)`
  padding: 2px 16px;
  color: ${(props) => props.theme.color.neutral.color3};
`

const WeeklyTimeText = styled(Text)<{ $isToday: boolean }>`
  color: ${({ theme, $isToday }) =>
    $isToday ? theme.color.status.primary : theme.color.neutral.color3};
`

const WeeklyContainer = styled.div`
  width: 100%;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export default Day
